<bb-transaction-signing-error *ngIf="errorValue; else displayForm"
  [error]="errorValue"
  (close)="onErrorClose($event)">
</bb-transaction-signing-error>

<ng-template #displayForm>
  <bb-alert-ui *ngIf="displayAlert"
    data-role="ts-hard-token-no-value-alert"
    i18n-title="No value alert title for hard token signing@@bb-hard-token-signing.alert.no-value.title"
    title="No value entered">
    <span i18n="No value alert message for hard token signing@@bb-hard-token-signing.alert.no-value.message">
      Please enter the value displayed on your {{ data.data.vendorDetails.model }} device.
    </span>
  </bb-alert-ui>
  <bb-alert-ui *ngIf="data.remainingAuthenticationAttempts !== undefined"
    data-role="ts-hard-token-remaining-alert"
    i18n-title="Remaining attempts alert title for hard token signing@@bb-hard-token-signing.alert.remaining.title"
    title="Authorization failed">
    <span i18n="Remaining attempts alert message for hard token signing@@bb-hard-token-signing.alert.remaining.message">
      The number you entered was incorrect. <br>
      You have {{data.remainingAuthenticationAttempts}} other {data.remainingAuthenticationAttempts, plural, =1 {attempt} other {attempts}} remaining.
    </span>
  </bb-alert-ui>
  <div class="bb-block bb-block--md" i18n="Instruction for hard token signing@@bb-hard-token-signing.instruction">
    Using your {{ data.data.vendorDetails.model }} device, follow these steps
  </div>

  <form [formGroup]="form" (submit)="onComplete()" class="bb-block bb-block--md">
    <ol class="bb-ordered-list bb-block bb-block--md">
      <li class="bb-block bb-block--sm">
        <span i18n="Step 1 for hard token signing@@bb-hard-token-signing.steps.1">
          Press '<strong>sign</strong>' on your device
        </span>
      </li>
      <li class="bb-block bb-block--sm">
        <span i18n="Step 2 for hard token signing@@bb-hard-token-signing.steps.2">
          Enter your pin in to your device
        </span>
      </li>
      <li class="bb-block bb-block--sm">
        <span i18n="Step 3 for hard token signing@@bb-hard-token-signing.steps.3">
          Enter the `reference number`
        </span>
        <br />
        <span class="bb-hero">
          {{ data.data.code }}
        </span>
      </li>
      <li class="bb-block bb-block--sm">
        <span i18n="Step 4 for hard token signing@@bb-hard-token-signing.steps.4">
          Enter the transaction amount
        </span>
        <br />
        <span class="bb-hero">
          {{ getTransactionAmount() }}
        </span>
      </li>
      <li class="bb-block bb-block--sm">
        <span i18n="Step 5 for hard token signing@@bb-hard-token-signing.steps.5">
          Insert the number produced on your {{ data.data.vendorDetails.model }} device
        </span>
        <br />
        <div class="form-group">
          <bb-input-text-ui
            data-role="ts-hard-token-otp"
            class="bb-form-field bb-form-field--xs"
            formControlName="otp"
            i18n-attr.aria-label="Aria label for otp field input@@bb-hard-token-signing.otp.aria-label"
            attr.aria-label="Insert the number produced on your {{data.data.vendorDetails.model}} device"
            [maxLength]="6"
            [minLength]="6">
          </bb-input-text-ui>
          <bb-input-validation-message-ui [showErrors]="hasError(form.controls.otp)">
            <span data-role="ts-hard-token-otp-error"
              i18n="Otp input length error message@@bb-hard-token-signing.otp.errors.length">
              The value must be exactly 6 numbers.
            </span>
          </bb-input-validation-message-ui>
        </div>
      </li>
    </ol>

    <div class="bb-button-bar">
      <button bbButton
        data-role="ts-hard-token-complete"
        class="bb-button-bar__button"
        color="primary"
        type="submit"
        i18n="Complete button@@bb-hard-token-signing.complete">
        Complete
      </button>
      <button bbButton 
        data-role="ts-hard-token-cancel"
        class="bb-button-bar__button"
        color="secondary"
        (click)="onCancel()"
        i18n="Cancel button@@bb-hard-token-signing.cancel">
        Cancel
      </button>
    </div>
  </form>
</ng-template>